import React from "react";
//local
import {IconMessage} from "components/icons";

const OfferDescription = ({message, title}) => {
  return (
    <div className="offer-card-view_message __wrapper">
      <h3 className="offer-card-view_message __title">
        <IconMessage addClass="mr-1" />
        {title}
      </h3>
      {message && <p>{message}</p>}
    </div>
  );
};

export default OfferDescription;
